export default "Review on the way ...\n\n<!-- Classic mad scientist laboratory, many props, good puzzles and game master. Diana & Helene. -->";